module.exports = __webpack_public_path__ + "img/hero.186ea8d6.jpg";